import {
  ACTIVE_TASK_COUNT,
  FILTER_TASK_AUTHOR_ID,
  FILTER_TASK_PERFORMER_ID,
} from '@/store/actions/tasks';

const mutations = {
  [ACTIVE_TASK_COUNT]: (state, count) => {
    state.activeTaskCount = count;
  },
  [FILTER_TASK_AUTHOR_ID]: (state, authorId) => {
    state.filterTaskAuthorId = authorId;
  },
  [FILTER_TASK_PERFORMER_ID]: (state, performerId) => {
    state.filterTaskPerformerId = performerId;
  },
};

const getters = {
  getActiveTaskCount: (state) => state.activeTaskCount,
  getFilterTaskAuthorId: (state) => state.filterTaskAuthorId,
  getFilterTaskPerformerId: (state) => state.filterTaskPerformerId,
};

const state = () => ({
  activeTaskCount: 0,
  filterTaskAuthorId: 0,
  filterTaskPerformerId: 0,
});

export default () => ({
  getters,
  mutations,
  state,
});
